import {
  getTimezoneAbbr,
  getTimezoneUtcOffsetStr,
} from '../../utils/timezone.utils';

export interface ITimezoneOption {
  value: string;
  label: string;
  searchTokens: string[];
}

export const toTimezoneOption = (name: string): ITimezoneOption => {
  const abbr = getTimezoneAbbr(name);
  const offset = getTimezoneUtcOffsetStr(name);
  const label = `${name} (${abbr}, ${offset})`;
  const parts = name.split('/').map((s) => s.toLowerCase());
  // Each word, and each multi-word place as written, e.g. 'new york'
  const segments = parts.flatMap((s) => [
    ...s.split('_'),
    ...(s.includes('_') ? [s.replace(/_/g, ' ')] : []),
  ]);
  const searchTokens = [
    name.toLowerCase(),
    abbr.toLowerCase(),
    offset.toLowerCase(),
    ...segments,
  ];
  return { value: name, label, searchTokens };
};
